export const HsaBankRetailPartnerId = 33;
